import {
  lookupStringInStringProvider,
  type StringProvider,
  type SupportedLocale,
} from "@1js/localization";
import { root } from "@fluentui-contrib/react-shadow";
import * as React from "react";

import { Localization } from "@1js/localization-components";
import {
  createCSSRuleFromTheme,
  FluentProvider,
} from "@fluentui/react-components";
import { CustomLightTheme } from "../../components/Styles";
import {
  CapabilitiesContainer,
  type CapabilitiesProps,
} from "./CapabilitiesContainer.web";
const CUSTOM_THEME_CLASS_NAME = "pl-theme";

export type CapabilitiesShadowContainerProps = CapabilitiesProps & {
  provider: StringProvider;
  locale: SupportedLocale;
};

export const CapabilitiesShadowContainer: React.FC<
  CapabilitiesShadowContainerProps
> = (props) => {
  const stringLookup = lookupStringInStringProvider(props.provider);
  const providerRef = React.useRef<HTMLElement>(null);
  React.useEffect(() => {
    // Use a Fluent theme to create a style rule
    // E.g., `.class-name { --vars ... }`
    // Fluent themes are all CSS vars so they pierce the
    // shadow DOM, we just need to ensure the class name
    // used here will match an element.
    const lightThemeCSS = createCSSRuleFromTheme(
      `.${CUSTOM_THEME_CLASS_NAME}`,
      CustomLightTheme
    );

    const sheet = new CSSStyleSheet();
    sheet.insertRule(lightThemeCSS);

    const shadowRoot = providerRef.current?.getRootNode() as ShadowRoot;

    if (shadowRoot.adoptedStyleSheets) {
      // Append the sheet so styles are available to shadow DOM
      shadowRoot.adoptedStyleSheets = [...shadowRoot.adoptedStyleSheets, sheet];
    }
  }, []);

  return (
    <Localization lookupString={stringLookup}>
      <FluentProvider
        className={CUSTOM_THEME_CLASS_NAME}
        theme={CustomLightTheme}
        ref={providerRef}
      >
        <root.div>
          <CapabilitiesContainer {...props}></CapabilitiesContainer>
        </root.div>
      </FluentProvider>
    </Localization>
  );
};
